import { Injectable, Injector } from "@angular/core";

import { AuthenticationService } from "./authentication.service";
import { I18nService } from "./i18n.service";
import { HttpWrapperService } from "./http.wrapper.service";
import { Router } from "@angular/router";
import { SessionManagerService } from "./SessionManager/session-manager.service";

import { observableToPromise } from "../admin/events-screen/utils/observableToPromise";
import { HttpErrorResponse } from "@angular/common/http";
import { SaveActionResult } from "../admin/events-screen/event-page-models/save-action-result";
import { ErrorType } from "../common/error-handler/error-types.enum";
import { eventFromInitDataObservableMock } from "../admin/events-screen/tests/fixtures/eventFromInitDataObservableMock";
import { EventSerializerService } from "./eventsServices/eventSerializer.service";
import {
  Circle,
  County,
  Nest,
} from "../admin/events-screen/event-page-models/noal.models";
import { OrganType } from "../_models/organ-type";

@Injectable()
export class GlobalDataService {
  constructor(
    private authenticationService: AuthenticationService,
    private i18nService: I18nService,
    private http: HttpWrapperService,
    private injector: Injector,
    private router: Router,
    private sessionManager: SessionManagerService
  ) {}

  public static serializeKehilotData(
    kehilot: Array<{
      id: number;
      name: string;
      has_add_permission: boolean;
      mehozot: Array<{
        id: number;
        name: string;
        has_add_permission: boolean;
        kenim: Array<{
          id: number;
          name: string;
          has_add_permission: boolean;
        }>;
      }>;
    }>
  ): { circles: Circle[]; counties: County[]; nests: Nest[] } {
    const result = {
      circles: [] as Circle[],
      counties: [] as County[],
      nests: [] as Nest[],
    };

    kehilot.forEach((kehila) => {
      const circle: Circle = {
        circleId: kehila.id,
        code: kehila.id.toString(),
        name: kehila.name,
        has_add_permission: kehila.has_add_permission !== false,
      };
      result.circles.push(circle);

      kehila.mehozot.forEach((mahoz) => {
        const county: County = {
          code: mahoz.id.toString(),
          countyId: mahoz.id,
          name: mahoz.name,
          parent: circle.circleId,
          has_add_permission: mahoz.has_add_permission !== false,
        };
        result.counties.push(county);

        mahoz.kenim.forEach((ken) => {
          const nest: Nest = {
            code: ken.id.toString(),
            name: ken.name,
            nestId: ken.id,
            parent: county.countyId,
            has_add_permission: ken.has_add_permission !== false,
          };
          result.nests.push(nest);
        });
      });
    });

    return result;
  }
  public static organTypeToText(
    organType: "nest" | "county" | "circle"
  ): string {
    switch (organType) {
      case "nest":
        return "קן";
      case "county":
        return "מחוז";
      case "circle":
        return "מעגל";
      default:
        return "לא ידוע";
    }
  }

  public async getAllPaymentFilters() {
    const rawResponse = await observableToPromise(
      this.http.get("/services/payment_filters")
    );
    return rawResponse.json();
  }
  public async getGlobalData(): Promise<SaveActionResult> {
    try {
      const rawResponse = await observableToPromise(
        this.http.get("/django-api/global/")
      );

      return { success: true, data: rawResponse.json() };
    } catch (e) {
      let error: HttpErrorResponse | ErrorType = e as HttpErrorResponse;
      if (error.status === 401) {
        error = ErrorType.Status_401_Unauthorized;
      }
      return {
        success: false,
        error,
      };
    }
  }
  public async getLegacyNodeGlobalData(): Promise<SaveActionResult> {
    try {
      const rawResponse = await observableToPromise(
        this.http.get("/api/global/")
      );
      return { success: true, data: rawResponse.json() };
    } catch (e) {
      let error: HttpErrorResponse | ErrorType = e as HttpErrorResponse;
      if (error.status === 401) {
        error = ErrorType.Status_401_Unauthorized;
      }
      return {
        success: false,
        error,
      };
    }
  }
  public async getOrgansWithPermissions(): Promise<SaveActionResult> {
    const allOrgansDataResult = await this.getOrganData();
    if (!allOrgansDataResult.success) {
      return allOrgansDataResult;
    }
    const allOrgansData = allOrgansDataResult.data as {
      circles: Circle[];
      counties: County[];
      nests: Nest[];
    };
    allOrgansData.circles = allOrgansData.circles.filter(
      (circle) => circle.has_add_permission
    );
    allOrgansData.counties = allOrgansData.counties.filter(
      (county) => county.has_add_permission
    );
    allOrgansData.nests = allOrgansData.nests.filter(
      (nest) => nest.has_add_permission
    );
    return {
      success: true,
      data: allOrgansData,
    };
  }
  public async getOrganData(): Promise<SaveActionResult> {
    try {
      const rawResponse = await observableToPromise(
        this.http.get("/django-api/global/get_all_kehilot_data/")
      );
      const json = rawResponse.json();

      const noalGlobalData = GlobalDataService.serializeKehilotData(
        json.kehilot
      );

      return { success: true, data: noalGlobalData };
    } catch (e) {
      let error: HttpErrorResponse | ErrorType = e as HttpErrorResponse;
      if (error.status === 401) {
        error = ErrorType.Status_401_Unauthorized;
      }
      return {
        success: false,
        error,
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/global-data.service.ts